/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AuthGuard } from '../../../../../core/guards';
import { ConsoleApiService } from '../../../shared/http/console.api.service';
import {
    ConsoleResolver,
    FirewallResolver,
    KeymapResolver,
    KeymapsResolver,
    ProxyResolver,
    SMTPResolver
} from '../../../shared/resolvers';
import { FirewallApiService } from '../../../shared/http/firewall.api.service';
import { KeyboardApiService } from '../../../shared/http/keyboard-api.service';
import { NgModule } from '@angular/core';
import { LoadbalancerSharedModule } from '../../../shared/loadbalancer.shared.module';
import { PhysicalAdvConfComponent } from './physicalAdvConf.component';
import { ProxyApiService } from '../../../shared/http/proxy.api.service';
import { SmtpApiService } from '../../../shared/http/smtp.api.service';

/**
 *
 */
@NgModule({
    imports: [
        LoadbalancerSharedModule
    ],
    declarations: [
        PhysicalAdvConfComponent,
    ],
    providers: [
        AuthGuard,
        ProxyResolver,
        FirewallResolver,
        ConsoleResolver,
        ConsoleApiService,
        KeymapsResolver,
        KeymapResolver,
        SMTPResolver,
        FirewallApiService,
        KeyboardApiService,
        ProxyApiService,
        SmtpApiService
    ]
})

export class PhysicalAdvConfigModule {
}
